import React from "react";
import { Link, useNavigate } from "react-router-dom";




const NotFound = () => {
  return (
    <div className="uk-section uk-flex uk-flex-middle uk-flex-center uk-height-viewport">
      <div className="uk-text-center">
        <h1 className="uk-heading-hero">Page Under Development</h1>
        <p className="uk-text-large">We’re working on it! The content you are looking for is currently under development. Please check back soon.</p>
        <Link className="uk-button uk-button-primary uk-margin-top" to = "/dashboard">
        
          Go Home
        </Link>
        
      </div>
    </div>
  );
};

export default NotFound;
